var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"olapic",attrs:{"id":"olapic_specific_widget"}})}
var staticRenderFns = []

export { render, staticRenderFns }